import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  accountNumber,
  apiKey,
  password,
  username,
  userPassMap,
} from '../internal.js'

const credentialTypes = [username, password, apiKey, accountNumber] as const
const locationCredentialTypes = ['customer-number', 'swoop-group'] as const

export type taxaCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]
export const taxaDocumentTypes = [
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const taxa: CarrierDef<taxaCredType> = {
  name: 'Tax-Air',
  scac: 'taxa',
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['api-key', 'apiKey'],
    ['account-number', 'accountNumber'],
    ['customer-number', 'ref2'],
    ['swoop-group', 'ref1'],
  ],
  engineLayers: ['rating', 'pickup', 'profinder', 'tracking', 'documents'],
  documentTypes: taxaDocumentTypes,
  credentialConfig: {
    'api-key': { hideFromFreightview: true },
    'customer-number': { hideFromFreightview: true },
  },
}
